import React from 'react';

import AlertsContext from './AlertsContext';

/**
* Exponer NotifyAlertProvider Component
*/
export { default as NotifyAlertProvider } from './NotifyAlertProvider';

/**
* Exponer NotifyAlert Reducer para usar con Redux
*/
export { default as NotifyAlertReducer } from './NotifyAlertProvider/reducer';

/**
 * HOC para que el componente pueda acceder al AlertsContext
 * y pueda llamar las alertas del provider.
 *
 * @param {React.Component|Function} WrappedComponent Componente
 * @returns {React.Component} Componente
 */
export default (WrappedComponent) => {

  return (props) => {

    return (
      <AlertsContext.Consumer>
        {(contextProps) => <WrappedComponent {...props} notifyAlertContext={contextProps} />}
      </AlertsContext.Consumer>
    );
  };
};



// WEBPACK FOOTER //
// ./src/containers/WithNotifyAlert/index.js